/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 彈出式警示視窗
 * @module web/components/AlertModal
 */

// ----- import from npm modules -----
import React, {useEffect, useState} from 'react';

const AlertModal = React.forwardRef((props, ref) => {
  const {title, message, memo, onConfirm, mode, onCancel} = props;
  const [style, setStyle] = useState({});

  const modeStyles = {
    disable: {
      badgeClass: 'modal__title__badge--warning',
      iconHref: '#ico-alert-circle',
      titleText: '確認停用？',
      buttonText: '停用',
      buttonClass: 'btn-primary',
    },
    enable: {
      badgeClass: 'modal__title__badge--success',
      iconHref: '#ico-check-circle',
      titleText: '確認啟用？',
      buttonText: '啟用',
      buttonClass: 'btn-success',
    },
    delete: {
      badgeClass: 'modal__title__badge--alert',
      iconHref: '#ico-trash',
      titleText: '確認刪除？',
      buttonText: '刪除',
      buttonClass: 'btn-primary',
    },
    approve: {
      badgeClass: 'modal__title__badge--success',
      iconHref: '#ico-check',
      titleText: '確認核可？',
      buttonText: '核可',
      buttonClass: 'btn-success',
    },
    resetPassword: {
      badgeClass: 'modal__title__badge--warning',
      iconHref: '#ico-lock',
      titleText: '確認重設密碼？',
      buttonText: '重設密碼',
      buttonClass: 'btn-primary',
    },
    resetVenderId: {
      badgeClass: 'modal__title__badge--warning',
      iconHref: '#ico-lock',
      titleText: '確認重設手機驗證碼？',
      buttonText: '重設驗證碼',
      buttonClass: 'btn-primary',
    },
  };

  useEffect(() => {
    setStyle(modeStyles[mode]);
  }, [mode]);

  return (
    <div ref={ref} className="modal fade" id="modalAlert" tabIndex="-1" aria-labelledby="modalAlertLabel">
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <form
          className="modal__form modal-content"
          id="modalAlertForm"
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          <div className="modal-header border-bottom-0">
            <h1 className="modal-title fs-5" id="modalAlertLabel">
              <div className={`modal__title__badge ${style.badgeClass}`} id="modalAlertBadge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={style.iconHref}></use>
                </svg>
              </div>
              <div id="modalAlertTitle" className="modal__title__text">
                {style.titleText || title}
              </div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                e.preventDefault();
                onCancel();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {message}
            {memo !== '' && <br />}
            <span className="modal-memo">{memo}</span>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
              onClick={(e) => {
                e.preventDefault();
                onCancel();
              }}
            >
              取消
            </button>
            <button type="submit" className={`btn ${style.buttonClass}`} id="modalAlertSumit">
              {style.buttonText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export {AlertModal};
export default AlertModal;
